/**
 * Created by pavel on 6/21/17.
 */

const geometryFunctions = {
  /**
   * @param A1 First point first line
   * @param A2 Second point first line
   * @param B1 First point second line
   * @param B2 Second point second line*/
  angleBetween2Lines(A1, A2, B1, B2) {
    let angle1 = (Math.atan2(A2.y - A1.y, A1.x - A2.x) * 180) / Math.PI;
    let angle2 = (Math.atan2(B2.y - B1.y, B1.x - B2.x) * 180) / Math.PI;
    let calculatedAngle = angle1 - angle2;
    if (calculatedAngle < 0) calculatedAngle += 360;
    calculatedAngle = Math.floor(calculatedAngle);
    return calculatedAngle;
  },
  /**
   * Calculate angle between two lines
   * @param A1 First point first line
   * @param A2 Second point first line
   * @param B1 First point second line
   * @param B2 Second point second line*/
  calculateScaleFactorByTwoLines(A1, A2, B1, B2) {
    let lengthA = Math.sqrt(Math.pow(A2.x - A1.x, 2) + Math.pow(A2.y - A1.y, 2));
    let lengthB = Math.sqrt(Math.pow(B2.x - B1.x, 2) + Math.pow(B2.y - B1.y, 2));
    return lengthB / lengthA;
  },
  // Greater if drag point farther
  calculateScaleFactorOnPreview(A1, A2, B1, B2) {
    let lengthA = Math.sqrt(Math.pow(A2.x - A1.x, 2) + Math.pow(A2.y - A1.y, 2));
    let lengthB = Math.sqrt(Math.pow(B2.x - B1.x, 2) + Math.pow(B2.y - B1.y, 2));
    return lengthA / lengthB;
  },
  /**
   * Calculate now point coordinates after rotation
   *
   * @param x             Point x
   * @param y             Point y
   * @param cx            Rotation center x
   * @param cy            Rotation center y
   * @param rotationAngle Angle to rotate
   * @return Rotated point
   */
  rotatePoint(x, y, cx, cy, rotationAngle) {
    let translatedAngle = 360 - rotationAngle;
    let radianAngle = translatedAngle * Math.PI / 180;
    let deltaX = x - cx;
    let deltaY = y - cy;
    let rotatedDeltaX = (deltaY * Math.sin(radianAngle) + deltaX * Math.cos(radianAngle));
    let rotatedDeltaY = (deltaY * Math.cos(radianAngle) - deltaX * Math.sin(radianAngle));
    return {
      x: rotatedDeltaX + cx,
      y: rotatedDeltaY + cy
    };
  },
  // Using this function for obtaining difference in stamp scale
  // and it's controls, "square divs on the corners", scale
  calculateScaleForControls(scale, squareSideLength) {
    let scaledSize = squareSideLength * scale;
    let onePercent = scaledSize / 100;
    let controlScale = squareSideLength / onePercent / 100;
    return controlScale;
  }

};

export default geometryFunctions;



// WEBPACK FOOTER //
// ./src/js/geometry.js